<script async setup>
import { defineProps, computed} from "vue";
import KdIcon from "./KdIcon.vue";

const props = defineProps({
    block: {
        type: Boolean,
        default: false,
    },
    icon: {
        type: String,
        default: "",
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    forceNewTab: {
        type: Boolean,
        default: false,
    },
    href: {
        type: String,
        default: "",
    },
    rel: {
        type: String,
        default: "noopener noreferrer",
    },
    type: {
        type: String,
        default: "button", // 'button', 'submit', 'reset'
    },
    variant: {
        type: String,
        default: "standard", // 'red', 'black'
    },
});

const emit = defineEmits(["click"]);

const handleClick = (event) => {
    emit("click", event);
};

const baseClasses = computed(() => {
  const variants = {
   red: "inline-flex items-center justify-center bg-ts-red text-white text-xs md:text-sm leading-none rounded-full py-2 px-3 border border-ts-red hover:bg-transparent hover:text-ts-red transition-colors duration-200",
   black: "inline-flex items-center justify-center bg-ts-black text-white text-xs md:text-sm leading-none rounded-full py-2 px-3 border border-ts-black hover:bg-transparent hover:text-ts-black transition-colors duration-200",
   white_hover: "inline-flex items-center justify-center bg-ts-black text-white text-xs md:text-sm leading-none rounded-full py-2 px-3 border border-ts-black hover:bg-white hover:text-ts-black transition-colors duration-200",
   white: "inline-flex items-center justify-center bg-ts-white text-black text-xs md:text-sm leading-none rounded-full py-2 px-3 border border-ts-black hover:border-ts-white hover:text-white hover:bg-black transition-colors duration-200",
  };
  const disabled = props.disabled ? "opacity-65 cursor-not-allowed" : "";
  const block = props.block ? "block" : "";
  
  return [
    variants[props.variant] || variants.black,
    disabled,
    block
  ].join(" ");
});

</script>

<template>
    <component
        :is="!props.href ? 'button' : 'kd-link'"
        :class="baseClasses"
        :type="props.type"
        :block="props.block"
        :disabled="props.disabled"
        :force-new-tab="props.forceNewTab"
        :href="props.href"
        :rel="props.rel"
        :variant="props.variant"
        @click="handleClick"
    >
        <div class="flex items-center justify-center gap-2">
            <kd-icon
                v-if="props.icon"
                :icon="props.icon"
                :size="16"
                class="text-inherit"
            />
            <slot />
        </div>
    </component>
</template>
